import { createSelector } from '@reduxjs/toolkit'
import type { PartialStoreState } from '../typings'

// HINT: default is hard coded until we handle multiple routing profiles
const selectDefaultRoutingProfile = (state: PartialStoreState) =>
  state.domain.publicData.domain.rm.routing.profiles.default

export const selectRoadSegments = createSelector(
  selectDefaultRoutingProfile,
  defaultRoutingProfile => {
    if (!defaultRoutingProfile) {
      throw new Error('default routing profile is missing')
    }

    return defaultRoutingProfile.segmentExceptions.reduce<
      Record<string, uui.domain.client.rm.SegmentException>
    >((acc, segmentException) => {
      acc[segmentException.id] = segmentException
      return acc
    }, {})
  },
)
